import Ayande from 'assets/images/banksWithNams/b_ayande.svg'
import Day from 'assets/images/banksWithNams/b_dey.svg'
import EghtesadNovin from 'assets/images/banksWithNams/b_eghtesad_novin.svg'
import Gardeshgari from 'assets/images/banksWithNams/b_gardeshgari.svg'
import IranVanazoela from 'assets/images/banksWithNams/b_iran_venezuela.svg'
import IranZamin from 'assets/images/banksWithNams/b_iranzamin.svg'
import Karafarin from 'assets/images/banksWithNams/b_karafarin.svg'
import Keshavarzi from 'assets/images/banksWithNams/b_keshavarzi.svg'
import Khavarmiane from 'assets/images/banksWithNams/b_khavarmiane.svg'
import Maskan from 'assets/images/banksWithNams/b_maskan.svg'
import MehrIran from 'assets/images/banksWithNams/b_mehr_iran.svg'
import Mellat from 'assets/images/banksWithNams/b_mellat.svg'
import Melli from 'assets/images/banksWithNams/b_melli.svg'
import Parsian from 'assets/images/banksWithNams/b_parsian.svg'
import Pasargad from 'assets/images/banksWithNams/b_pasargad.svg'
import Refah from 'assets/images/banksWithNams/b_refah.svg'
import Resalat from 'assets/images/banksWithNams/b_resalat.svg'
import Saderat from 'assets/images/banksWithNams/b_saderat.svg'
import Saman from 'assets/images/banksWithNams/b_saman.svg'
import SanatMadan from 'assets/images/banksWithNams/b_sanat_madan.svg'
import Sarmaye from 'assets/images/banksWithNams/b_sarmaye.svg'
import Sepah from 'assets/images/banksWithNams/b_sepah.svg'
import Shahar from 'assets/images/banksWithNams/b_shahr.svg'
import Sina from 'assets/images/banksWithNams/b_sina.svg'
import Taavon from 'assets/images/banksWithNams/b_taavon.svg'
import Tejarat from 'assets/images/banksWithNams/b_tejarat.svg'
import ToseeSaderat from 'assets/images/banksWithNams/b_tosee_saderat.svg'
export const BankNameConvertor: { [key: string]: string } = {
    b_ayande: Ayande,
    b_dey: Day,
    b_eghtesad_novin: EghtesadNovin,
    b_gardeshgari: Gardeshgari,
    b_iran_venezuela: IranVanazoela,
    b_iranzamin: IranZamin,
    b_karafarin: Karafarin,
    b_keshavarzi: Keshavarzi,
    b_khavarmiane: Khavarmiane,
    b_maskan: Maskan,
    b_mehr_iran: MehrIran,
    b_mellat: Mellat,
    b_melli: Melli,
    b_parsian: Parsian,
    b_pasargad: Pasargad,
    b_refah: Refah,
    b_resalat: Resalat,
    b_saderat: Saderat,
    b_saman: Saman,
    b_sanat_madan: SanatMadan,
    b_sarmaye: Sarmaye,
    b_sepah: Sepah,
    b_shahr: Shahar,
    b_sina: Sina,
    b_taavon: Taavon,
    b_tejarat: Tejarat,
    b_tosee_saderat: ToseeSaderat,
}
